"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = exports.Video = exports.Match = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Match(_a) {
    var user = _a.user, video = _a.video, setVideo = _a.setVideo, channel = _a.channel;
    var Tab = storybook_1.Videos['FormMatch' + channel.type.ucfirst()];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Tab, { video: video, setVideo: setVideo, channel: channel, user: user }),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { type: 'date', value: video.date, onChange: function (date) { return setVideo({ date: date }); } })));
}
exports.Match = Match;
function Video(_a) {
    var video = _a.video, setVideo = _a.setVideo, categories = _a.categories;
    return react_1.default.createElement(storybook_1.Videos.FormFields, { video: video, setVideo: setVideo, categories: categories });
}
exports.Video = Video;
function Share(_a) {
    var video = _a.video;
    return react_1.default.createElement(storybook_1.Videos.Share, { video: video });
}
exports.Share = Share;
